import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorParser } from '@app/classes';
import { Employee } from '@app/models/employee/employee.model';
import { VacationYtdAdjusterService } from '@app/modules/payroll/services';
import { AuthService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { Subscription } from 'rxjs';

@Component({
    templateUrl: './make-vacation-ytd-adjustment.form.template.html',
    styleUrls: ['./make-vacation-ytd-adjustment.form.style.scss'],
})
export class MakeVacationYtdAdjustmentForm extends BaseForm implements OnInit, OnDestroy {
    isLoading = true;
    employee: Employee;
    routeSubscription$: Subscription;
    latestEmployeeVacationYtdAdjustment: string;
    adjustmentAmountInputted: string;
    addOrSubtractAdjustmentCalculation = 'add';
    calculatedYtdBalanceAmount: string;
    adjustmentMessage: string;
    adjustmentHasBeenCalculated = false;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private vacationYtdAdjusterService: VacationYtdAdjusterService,
        private router: Router
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.routeSubscription$ = this.route.params.subscribe(async (params) => {
            const employeeId = params['employee'];
            this.employee = await Employee.param('company', this.auth.company.id).find(employeeId);
            await this.fetchLatestEmployeeVacationYtdAdjustment(employeeId);
            this.isLoading = false;
        });
    }

    ngOnDestroy() {
        this.routeSubscription$.unsubscribe();
    }

    onCalculateYTDBalance() {
        if (!this.submitAndValidate()) {
            return;
        }
        const currentBalance =
            this.latestEmployeeVacationYtdAdjustment === null ? '0' : this.latestEmployeeVacationYtdAdjustment;
        if (this.addOrSubtractAdjustmentCalculation === 'add') {
            this.calculatedYtdBalanceAmount = (parseFloat(currentBalance) + parseFloat(this.adjustmentAmountInputted))
                .toFixed(2)
                .toString();
        } else {
            this.calculatedYtdBalanceAmount = (parseFloat(currentBalance) - parseFloat(this.adjustmentAmountInputted))
                .toFixed(2)
                .toString();
        }
        this.adjustmentHasBeenCalculated = true;
    }

    onRedirect() {
        this.router.navigate(['/payroll/vacation-ytd-adjuster']);
    }

    submitAndValidate(): boolean {
        this.submit();
        return this.valid;
    }

    async fetchLatestEmployeeVacationYtdAdjustment(employeeId: string) {
        try {
            this.latestEmployeeVacationYtdAdjustment =
                await this.vacationYtdAdjusterService.fetchLatestEmployeeVacationYtdAdjustment(employeeId);
            this.calculatedYtdBalanceAmount = this.latestEmployeeVacationYtdAdjustment;
        } catch (error) {
            this.notify.error(ErrorParser.parse(error));
            this.isLoading = false;
        }
    }

    async onSave() {
        if (!this.submitAndValidate()) {
            return;
        }
        try {
            let adjustmentAmount = this.adjustmentAmountInputted;
            if (this.addOrSubtractAdjustmentCalculation === 'subtract') {
                adjustmentAmount = '-' + this.adjustmentAmountInputted;
            }
            await this.vacationYtdAdjusterService.saveEmployeeVacationYtdAdjustment(
                this.employee.id,
                adjustmentAmount,
                this.adjustmentMessage
            );
            this.notify.success('Adjustment has been made succesfully');
            this.onRedirect();
        } catch (error) {
            this.notify.error(ErrorParser.parse(error));
        }
    }
}
